// extracted by mini-css-extract-plugin
export var banner = "_hn-0";
export var closeButton = "_hn-2";
export var greenCheckmark = "_hn-3";
export var hereLink = "_hn-4";
export var titleIcon = "_hn-1";